import React, { useMemo } from "react";
import clsx from "clsx";

import { Context } from "../../../../../../teacherStore";
import { IActiveLearningIssue } from "../../../../../../state";
import { getStudentAnswersByQuestion } from "../../../../../../libs/ActiveLearning";
import AnswerStats from "../../../../../../atoms/ActiveLearning/AnswerStats";
import StudentAnswer from "../../../../../../molecules/ActiveLearning/StudentAnswer";
import styles from "../../../ActiveLearningIssue.module.scss";
import stylesAnswer from "../../../ActiveLearningAnswer.module.scss";

type Issue2AnswerProps = {
  materialCode: string;
  lessonNo: number;
  issue?: IActiveLearningIssue | undefined;
};

export const Issue2Answer = (props: Issue2AnswerProps) => {
  const { state } = React.useContext(Context);
  const currentIssueNo = 2;

  const question1 = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 1);
  }, [props.issue?.questions]);

  const answersSortedByStudentName = useMemo(() => {
    return state.active_learning_answers?.sort((a, b) => {
      return a.last_name_kana.localeCompare(b.last_name_kana, "ja");
    });
  }, [state.active_learning_answers]);

  const studentAnswersI2 = useMemo(() => {
    return answersSortedByStudentName?.map(studentAnswers => {
      const filteredAnswers = getStudentAnswersByQuestion(
        props.materialCode,
        studentAnswers,
        props.lessonNo,
        currentIssueNo,
      );

      return {
        ...studentAnswers,
        answers: filteredAnswers,
      };
    });
  }, [answersSortedByStudentName, props.materialCode, props.lessonNo]);

  const studentAnswerStatsI2 = useMemo(() => {
    const answered =
      studentAnswersI2?.filter(
        studentAnswers => studentAnswers.answers.length > 0,
      ).length || 0;
    const total = studentAnswersI2?.length || 0;
    const unanswered = total - answered;

    return {
      answered,
      total,
      unanswered,
    };
  }, [studentAnswersI2]);

  return (
    <div key={props.issue?.no} className={styles.issue}>
      <div className={clsx(styles.question, styles.primary)}>
        <div className={styles.header}>
          <span className={styles.no}>
            WORK
            {props.issue?.no && props.issue?.no < 10
              ? `0${props.issue?.no}`
              : props.issue?.no}
          </span>
          <p className={styles.title}>{props.issue?.title}</p>
          <AnswerStats
            answered={studentAnswerStatsI2.answered}
            total={studentAnswerStatsI2.total}
            unanswered={studentAnswerStatsI2.unanswered}
          />
        </div>
        {question1 && (
          <div className={styles.answersArea}>
            {studentAnswersI2?.map((studentAnswers, index) => {
              const no = index + 1;
              const displayNo = no < 10 ? `0${no}` : `${no}`;
              const isAnswered = studentAnswers.answers.length > 0;
              return (
                <StudentAnswer
                  key={studentAnswers.student_id}
                  isAnswered={isAnswered}
                  isAccordion
                  no={displayNo}
                  name={`${studentAnswers.last_name} ${studentAnswers.first_name}`}
                  classId={studentAnswers.class_id}
                  studentId={studentAnswers.student_id}
                >
                  {isAnswered && (
                    <div className={styles.answersWrap}>
                      {studentAnswers.answers.map(answer => (
                        <div key={answer.id} className={stylesAnswer.tree}>
                          <p className={stylesAnswer.answer}>
                            {answer.contents.subject ||
                              "回答データがありません。"}
                          </p>
                          <ul className={stylesAnswer.branchList}>
                            <li className={stylesAnswer.branch}>
                              <div className={stylesAnswer.labelWrapper}>
                                <span className={stylesAnswer.label}>原因</span>
                              </div>
                              <p className={stylesAnswer.answer}>
                                {answer.contents.reason ||
                                  "回答データがありません。"}
                              </p>
                            </li>
                            <li className={stylesAnswer.branch}>
                              <div className={stylesAnswer.labelWrapper}>
                                <span className={stylesAnswer.label}>
                                  理想状況
                                </span>
                              </div>
                              <p className={stylesAnswer.answer}>
                                {answer.contents.value ||
                                  "回答データがありません。"}
                              </p>
                            </li>
                          </ul>
                        </div>
                      ))}
                    </div>
                  )}
                </StudentAnswer>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};
export default Issue2Answer;
